<template>
    <div class="customerList-module">

        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad" :offset="20" :immediate-check="false">
                    <div class="customer-list flex-col" v-for="(item, index) in roomList" :key="index" @click="toDetail(item.custId, item.phone)">
                        <div class="customer-list-box flex-col ">
                            <div class="customer-outer flex-row">
                                <div class="customer-group flex-col">
                                    <div class="customer-info flex-row">
                                        <img class="headPortrait" referrerpolicy="no-referrer" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="" />
                                        <div class="customer-info-box flex-col">
                                            <div class="customer-main flex-row">
                                                <span class="name" v-html="item.username"></span>
                                                <div class="card-grade flex-col">
                                                    <img class="card-image" v-if="item.cardImageSmallUrl" referrerpolicy="no-referrer" :src="item.cardImageSmallUrl" alt="" />
                                                </div>
                                            </div>
                                            <span class="mobile" v-html="item.resMobile"></span>
                                        </div>
                                    </div>
                                    <div class="membership-box flex-row">
                                        <span class="membership-attributes">会员属性：{{ item.customerType }}</span>
                                        <div v-if="item.lifeBeautyCustomerActivity" class="membership-div flex-col">
                                            <span class="membership-tag" v-html="item.lifeBeautyCustomerActivity"></span>
                                        </div>
                                    </div>
                                    <span class="card-balance">卡内余额：{{ item.balance ? item.balance : 0 }}元</span>
                                </div>
                            </div>
                            <span class="arrived-store">最近来店：{{ item.lastStoreName }} {{ item.lastTime }}</span>
                        </div>
                        <div class="brithday flex-col">
                            <span class="brithday-txt" v-html="item.birthday"></span>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { DropdownMenu, DropdownItem, Search, Toast } from "vant";
    import { getCurExternalChat, getCurExternalContact } from '@/utils/wxCodeAuth'

    export default {
        name: "customerGroupList",
        components: {
            [Search.name]: Search,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
        },
        data() {
            return {
                custId: "", //顾客id
                phone: "", //顾客手机号
                searchStr: '',  // 搜索条件
                roomListPage: 1,
                page: 1,
                total: 0,
                roomList: [],//列表
                loading: false,
                finished: false,
                refreshing: false,
            };
        },
        mounted() {
            this.page = this.$route.query.customerListPage || this.page
            this.searchStr = this.$route.query.customerListSearchStr || this.searchStr
            sessionStorage.removeItem('customListActive');
            this.onLoad();
        },
        methods: {
            async onLoad() {
                const chatId = this.$route.query.chatId
                await this.getGroupList(chatId)
            },
            // 获取群id
            async judgeGroupId() {
                // getCurExternalChat('').then(async (chatId) => {
                //     await this.getGroupList(chatId)
                // }).catch(async () => {
                //     const userId = await getCurExternalContact('')
                // })
            },
            // 获取群成员列表
            getGroupList(chatId) {
                return request({
                    url: `/contact/roomContactPage?workRoomId=${chatId}&limit=10&page=${this.page}`,
                    method: "get",
                }).then((res) => {
                    this.roomList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                    this.roomListPage = this.page;
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    if (this.roomList.length >= this.total) {
                        this.finished = true;
                    }
                });
            },
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.roomList = [];
                this.refreshing = false;
                this.onLoad();
            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
        },
    };
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .customerList-module {
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02) inset;
        padding: 10px 10px;
    }

    .txt {
        color: #a0acb5;
    }

    .tab-box {
        padding: 1px 30px 0 30px;
    }

    :deep(.van-tabs__line) {
        display: none;
    }

    :deep(.van-tab) {
        /* flex: none !important; */
        /* flex:0 0 25%!important; */
        width: 190px;
        padding: 0 !important;
        height: 70px !important;
        line-height: 70px !important;
        color: #a0acb5;
        font-size: 30px;
    }

    :deep(.van-tab.van-tab--active) {
        /* width: 184rpx !important; */
        height: 70px !important;
        line-height: 70px;
        background: #2fd0d5 !important;
        border-radius: 35px !important;
        color: #fff !important;
    }

    :deep(.van-field__left-icon) {
        margin-top: 5px;
    }

    :deep(.van-field__control) {
        font-size: 24px !important;
        color: #a0acb5 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    .search-box {
        height: 115px;
    }

    :deep(.van-dropdown-menu) {
        box-shadow: none !important;
    }

    :deep(.van-dropdown-menu__title) {
        font-size: 24px !important;
        color: #35434c !important;
    }

    :deep(.van-list__finished-text) {
        height: 280px !important;
    }

    .list-box {
        /* width: 690px; */
        width: 100%;
        height: 100vh;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 0 0 250px 0;
    }

    .customer-list {
        z-index: 35;
        height: 331px;
        border-radius: 30px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        width: 690px;
        position: relative;
        margin: 28px auto;
    }

    .customer-list-box {
        width: 632px;
        height: 269px;
        margin: 30px 0 0 28px;
    }

    .customer-outer {
        width: 630px;
        height: 212px;
        margin-left: 2px;
    }

    .customer-group {
        width: 325px;
        height: 212px;
    }

    .customer-info {
        width: 320px;
        height: 88px;
    }

    .headPortrait {
        width: 88px;
        height: 88px;
        border-radius: 12px;
    }

    .customer-info-box {
        width: 212px;
        height: 88px;
        margin-left: 20px;
    }

    .customer-main {
        width: 400px;
        height: 48px;
    }

    .name {
        max-width: 260px;
        min-width: 128px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        line-height: 48px;
        text-align: left;
        overflow: hidden;
        /*溢出的部分隐藏*/
        white-space: nowrap;
        /*文本不换行*/
        text-overflow: ellipsis;
        /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
    }

    .card-grade {
        height: 34px;
        border-radius: 17px;
        margin-top: 6px;
        /* width: 150px; */
        margin-left: 20px;
    }

    .txt3 {
        width: 66px;
        height: 30px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 30px;
        text-align: left;
        margin: 2px 0 0 12px;
    }

    .card-image {
        height: 36px;
        width: 94px;
    }

    .mobile {
        width: 147px;
        height: 37px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 3px;
    }

    .membership-box {
        width: 325px;
        height: 37px;
        margin-top: 30px;
    }

    .membership-attributes {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
    }

    .membership-div {
        height: 34px;
        border-radius: 17px;
        border: 2px solid rgba(47, 208, 213, 1);
        margin-left: 20px;
        padding: 0 5px;
    }

    .membership-tag {
        height: 30px;
        display: inline-block;
        color: rgba(47, 208, 213, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 30px;
        text-align: left;
        margin: 0 auto 0;
    }

    .card-balance {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .tag-group {
        width: 37px;
        height: 37px;
        background: linear-gradient(147deg, #ffdc8d 0%, #ba8714 100%);
        border-radius: 23px;
        margin: 6px 0 10px 10px;
    }

    .tag-name {
        width: 28px;
        height: 30px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 30px;
        text-align: left;
        margin: 3px auto 0;
    }

    .wechat {
        width: 100px;
        height: 100px;
        margin: 86px 0 0 136px;
    }

    .arrived-store {
        width: 579px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .brithday {
        z-index: 46;
        height: 148px;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/birthdayTag.png) 0px -40px no-repeat;
        background-size: 235px 188px;
        width: 204px;
        position: absolute;
        left: 486px;
        top: 0;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .brithday-txt {
        width: 81px;
        height: 73px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        margin: 27px 0 0 121px;
        transform: rotate(35deg);
        -webkit-transform-origin-x: 5px;
    }
</style>
